<template>
    <div>
        <simple :contacto="contacto" v-if="type == 'simple'"></simple>
        <extend :contacto="contacto" v-if="type == 'extend'"></extend>
    </div>
</template>

<script>
    import Simple from './Simple.vue';
    import Extend from './Extend.vue';
    import ContactData from './FormData';
    let contactInfo = new ContactData();
    export default
    {
        props : {
            type : {
                type : String,
                default : 'simple'
            }
        },
        data : function(){
            return {
                contacto : contactInfo
            }
        },
        components : {
            'simple' : Simple,
            'extend' : Extend
        }
    }
</script>


// WEBPACK FOOTER //
// Contact.vue?12bc2362